export { default as gdmFeedbackModalSetOldActions } from './gdmFeedbackModalSetOldActions';

export type {
  GDMFeedbackModalSetOldActionsFunction,
  GDMFeedbackModalSetOldActionsPayload,
} from './gdmFeedbackModalSetOldActions.type';
